'use client';

import { asText, RichTextField } from '@prismicio/client';

import { Locales as PrismicLocales } from '@preventx/prismic-services';

// Contexts
import { useSiteNavigationContext } from '@/context/SiteNavigationProvider';

type LocalesProps = {
  label: RichTextField;
};

export const Locales = ({ label }: LocalesProps) => {
  const { locales } = useSiteNavigationContext();

  if (locales.length === 0) {
    return null;
  }

  return <PrismicLocales label={asText(label)} locales={locales} />;
};
